"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDeepCopy = void 0;

/**
 * Utility function to create a deep copy of an object or array.
 * This is used to ensure immutability when working with complex data structures.
 *
 * @param {T} data - The object or array to be deeply copied.
 * @returns {T} - A deep copy of the input data.
 */
var createDeepCopy = function createDeepCopy(data) {
  return JSON.parse(JSON.stringify(data));
};

exports.createDeepCopy = createDeepCopy;